// src/components/auth/PolicyPage.js
import React from 'react';
import { css } from '../../App';

function PolicyPage({ user, onAccept, onSignOut }) {
  const bizName = user.businessName || "your workspace";
  return (
    <><style>{css}</style>
      <div className="official-screen">
        <section className="official-brand-panel">
          <div>
            <div className="official-mark">{bizName[0] || "E"}</div>
            <h1>{bizName}</h1>
            <p>A professional operating system for orders, sales, inventory, expenses, people, and business reporting.</p>
          </div>
          <div className="official-proof">
            <span>✓ Role-based access for each staff member</span>
            <span>✓ Business records kept under your approved workspace</span>
            <span>✓ Audit-friendly activity and financial controls</span>
          </div>
        </section>
        <main className="official-main-panel">
          <div className="official-card">
            <div className="official-eyebrow">Workspace Policy</div>
            <h2>Before you continue</h2>
            <p>Please review and accept these operating rules. They help keep client data reliable, secure, and ready for management decisions.</p>
            <div className="policy-list">
              <div className="policy-item"><span className="policy-icon">1</span><div><strong>Use accurate business data</strong><p>Enter real orders, expenses, inventory, payments, and sales only when they have been confirmed by the business.</p></div></div>
              <div className="policy-item"><span className="policy-icon">2</span><div><strong>Protect account access</strong><p>Use only your approved Google account and sign out on shared devices. Do not share access with unapproved users.</p></div></div>
              <div className="policy-item"><span className="policy-icon">3</span><div><strong>Respect approval workflows</strong><p>Pending expenses, restocks, sales, and withdrawals must be reviewed by the correct role before they become official records.</p></div></div>
              <div className="policy-item"><span className="policy-icon">4</span><div><strong>Keep client records confidential</strong><p>Customer, staff, financial, and operational details should only be used for the business purpose of this workspace.</p></div></div>
            </div>
            <div className="official-actions">
              <button className="btn btn-primary" onClick={onAccept}>Accept and Continue</button>
              <button className="btn btn-secondary" onClick={onSignOut}>Sign Out</button>
            </div>
          </div>
        </main>
      </div></>
  );
}

export default PolicyPage;